import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import ReactDataGrid from 'react-data-grid';
import { Data, Toolbar } from 'react-data-grid-addons';
import moment from 'moment';
import { addCommas, getOrderStatus } from '../../utils/common';
import { SIMPLE_DATE_FORMAT } from '../../config/app_config';

const StatusColumnFormatter = React.createClass({
  propTypes: {
    value: React.PropTypes.string.isRequired,
  },

  getStatusStyle() {
    if (this.props.value === 'Expired') {
      return {
        color: 'danger',
      };
    } else if (this.props.value === 'Expiring') {
      return {
        color: 'warning',
      };
    }
    return {
      color: 'success',
    };
  },

  render() {
    return (
      <span>
        <i className={`text-${this.getStatusStyle().color} fa fa-circle`} />
        &nbsp;
        {this.props.value}
      </span>
    );
  },
});

const TABLE_COLUMNS = [
  { key: 'orderNumber', name: 'Order #' },
  { key: 'name', name: 'Name', width: 145 },
  { key: 'platform', name: 'Platform' },
  { key: 'list', name: 'List' },
  { key: 'sku', name: 'SKU' },
  { key: 'creditsRemaining', name: 'Credits Remaining', width: 160 },
  { key: 'createdOn', name: 'Created On' },
  { key: 'endDate', name: 'End Date' },
  { key: 'billable', name: 'Billable' },
  { key: 'status', name: 'Status', formatter: StatusColumnFormatter },
  { key: 'viewOrder', name: 'Details', width: 85 },
];

export default class OrdersIndex extends React.Component {
  static propTypes = {
    account: PropTypes.object.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    minHeight: PropTypes.number.isRequired,
    orders: PropTypes.object.isRequired,
  };

  state = {
    rows: [],
    originalRows: [],
    columns: TABLE_COLUMNS,
    filters: {
      statusGroup: {
        column: { key: 'statusGroup' },
        filterTerm: 'active',
      },
    },
  };

  componentWillMount = () => {
    const { account, isSuperAdmin, orders } = this.props;

    let tableColumns = TABLE_COLUMNS;
    if (isSuperAdmin) {
      tableColumns = tableColumns.filter(c => c.key !== 'sku' && c.key !== 'creditsRemaining');
    }
    if (!account.get('creditsEnabled')) {
      tableColumns = tableColumns.filter(c => c.key !== 'creditsRemaining');
    }

    const columnArray = tableColumns.map(c => {
      const copy = Object.assign({}, c);
      copy.filterable = true;
      copy.resizable = true;
      if (copy.key !== 'useCase') {
        copy.sortable = true;
      }
      if (copy.key === 'viewOrder') {
        copy.sortable = false;
        copy.filterable = false;
      }
      return copy;
    });

    this.setState({
      columns: columnArray,
    });
    this.renderRows(orders);
  };

  componentWillReceiveProps = nextProps => {
    const { orders } = nextProps;
    if (orders.size > 0) {
      this.renderRows(orders);
    }
  };

  onClearFilters = () => {
    // all filters removed
    this.setState({
      filters: {},
    });
  };

  getRows = () => Data.Selectors.getRows(this.state);

  getSize = () => this.getRows().length;

  rowGetter = rowIdx => {
    const rows = this.getRows();
    return rows[rowIdx];
  };

  parseCreditsRemainingToInt = rows =>
    rows.map(row => {
      const { creditsRemaining } = row;
      return creditsRemaining
        ? { ...row, creditsRemaining: parseInt(row.creditsRemaining.replace(/,/g, ''), 10) }
        : row;
    });

  parseCreditsRemainingToString = rows =>
    rows.map(row => {
      const { creditsRemaining } = row;
      return creditsRemaining ? { ...row, creditsRemaining: addCommas(row.creditsRemaining) } : row;
    });

  handleGridSort = (sortColumn, sortDirection) => {
    const { originalRows, rows } = this.state;
    const rowsToSort = this.parseCreditsRemainingToInt(rows);
    const priorityWeights = {
      Active: 0,
      Expiring: 1,
      Expired: 2,
    };
    const comparer = (a, b) => {
      if (sortDirection === 'ASC') {
        if (sortColumn === 'prematched') {
          return parseInt(a[sortColumn].key, 10) > parseInt(b[sortColumn].key, 10) ? 1 : -1;
        } else if (sortColumn === 'status') {
          return priorityWeights[a[sortColumn]] > priorityWeights[b[sortColumn]] ? 1 : -1;
        } else if (sortColumn === 'createdOn' || sortColumn === 'endDate') {
          return new Date(a[sortColumn]).getTime() > new Date(b[sortColumn]).getTime() ? 1 : -1;
        }
        return a[sortColumn] > b[sortColumn] ? 1 : -1;
      } else if (sortDirection === 'DESC') {
        if (sortColumn === 'prematched') {
          return parseInt(a[sortColumn].key, 10) < parseInt(b[sortColumn].key, 10) ? 1 : -1;
        } else if (sortColumn === 'status') {
          return priorityWeights[a[sortColumn]] < priorityWeights[b[sortColumn]] ? 1 : -1;
        } else if (sortColumn === 'createdOn' || sortColumn === 'endDate') {
          return new Date(a[sortColumn]).getTime() < new Date(b[sortColumn]).getTime() ? 1 : -1;
        }
        return a[sortColumn] < b[sortColumn] ? 1 : -1;
      }
      return null;
    };
    const rowsSorted = sortDirection === 'NONE' ? originalRows.slice() : rowsToSort.sort(comparer);
    const newRows = this.parseCreditsRemainingToString(rowsSorted);
    this.setState({
      rows: newRows,
    });
  };

  handleRowUpdated = e => {
    // merge updated row with current row and rerender by setting state
    const { rows } = this.state;
    Object.assign(rows[e.rowIdx], e.updated);
    this.setState({
      ...rows,
    });
  };

  handleFilterChange = filter => {
    const { filters } = this.state;
    const newFilters = Object.assign({}, filters);
    const isFilterCredits =
      filter.column.key === 'creditsRemaining' &&
      parseInt(filter.filterTerm, 10) &&
      !/,/.test(filter.filterTerm);
    const newFilter = isFilterCredits
      ? { ...filter, filterTerm: addCommas(parseInt(filter.filterTerm, 10)).toString() }
      : filter;
    if (newFilter.filterTerm) {
      newFilters[filter.column.key] = newFilter;
    } else {
      delete newFilters[filter.column.key];
    }
    this.setState({
      filters: newFilters,
    });
  };

  handleStatusChange = e => {
    const filter = {
      filterTerm: e.target.value,
      column: { key: e.target.name },
    };
    this.handleFilterChange(filter);
  };

  renderRows = orders => {
    const _rows = [];
    orders.map(o => {
      const status = getOrderStatus(o.order.endDate);
      _rows.push({
        key: o.order.id,
        id: o.order.id,
        status: status.text,
        statusGroup: status.group,
        name: o.order.company.name,
        orderNumber: o.order.providerOrderNumber,
        platform: o.platformUseCases[0].platform.description,
        list: this.renderMulti(o.listSKUs, 'dataSet', 'name'),
        sku: this.renderMulti(o.listSKUs, 'fieldSet', 'name'),
        creditsRemaining: o.creditsRemaining ? addCommas(o.creditsRemaining) : 'No Credits',
        createdOn: moment(o.order.createdOn).format(SIMPLE_DATE_FORMAT),
        endDate: moment(o.order.endDate).format(SIMPLE_DATE_FORMAT),
        billable: o.order.isBillable ? 'Yes' : 'No',
        viewOrder: this.renderViewOrderButton(o),
      });
      return _rows;
    });
    return this.setState({
      rows: _rows,
      originalRows: _rows.slice(),
    });
  };

  renderMulti = (multi, itemName, subItemName) => {
    const objectArray = multi.map(object => object[itemName][subItemName]);

    return objectArray.join('\n');
  };

  renderViewOrderButton = o => (
    <Link
      title={o.order.providerOrderNumber}
      to={`/orders/order/${o.order.id}`}
      className="center-block"
    >
      View
    </Link>
  );

  render() {
    const { orders, minHeight } = this.props;
    const { columns } = this.state;
    return (
      <span>
        <div className="radio">
          <label htmlFor="active">
            <input
              type="radio"
              name="statusGroup"
              value="active"
              defaultChecked
              onChange={this.handleStatusChange}
            />
            &nbsp;Active
          </label>
          <br />
          <label htmlFor="expired">
            <input
              type="radio"
              name="statusGroup"
              value="expired"
              id="expired"
              onChange={this.handleStatusChange}
            />
            &nbsp;Expired
          </label>
        </div>
        <div>
          {orders === undefined || orders.size === 0 ? (
            <p>Your account has no orders</p>
          ) : (
            <ReactDataGrid
              onGridSort={this.handleGridSort}
              rowKey="key"
              id="key"
              columns={columns}
              rowGetter={this.rowGetter}
              rowsCount={this.getSize()}
              onRowUpdated={this.handleRowUpdated}
              toolbar={<Toolbar enableFilter />}
              onAddFilter={this.handleFilterChange}
              onClearFilters={this.onClearFilters}
              minHeight={minHeight}
              filterRowsButtonText="Search By Field"
            />
          )}
        </div>
      </span>
    );
  }
}
